import React from "react";

function ButtonRow({
  btn1Text,
  btn1Action,
  btn2Text,
  btn2Action,
  href1,
  href2,
}) {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          marginTop: 16,
          marginBottom: 16,
        }}
      >
        <a className="ahp-button" onClick={btn1Action} href={href1}>
          {btn1Text}
        </a>
        <a className="ahp-button" onClick={btn2Action} href={href2}>
          {btn2Text}
        </a>
      </div>
    </>
  );
}

export default ButtonRow;
